
@for(facet of facets; track facet.id) {
    <details (click)="recalcMaxWidth()" onmouseleave="window.matchMedia('(min-width: 1280px)').matches ? this.open = false : null">
        <summary [attr.selected]="facet.values | someSelected">{{ facet.title }}</summary>
        @if(facet.id === 'price') {
            @for (facetValue of facet.values; track facetValue.value+facetValue.selected) {
                <label >
                    <input type="checkbox"
                    [name]="'facet_'+facet.id"
                    [id]="facetValue?.value"
                    [attr.checked]="facetValue?.selected ? '' : null"
                    [value]="facetValue?.value"

                    (input)="updateUrl()">
                    <span>{{facetValue?.title ?? facetValue?.value}}</span>
                </label>
            }
        } @else {
            @for (facetValue of facet.values; track facetValue.value+facetValue.selected) {
                <label >
                    <input type="checkbox"
                    [name]="'facet_'+facet?.id"
                    [id]="facetValue?.value"
                    [attr.checked]="facetValue?.selected ? '' : null"
                    [value]="facetValue?.value"

                    (input)="updateUrl()"
                    >
                    <span>{{facetValue?.title ?? facetValue?.value}}</span>
                </label>
        }
        }
    </details>
}
